import { render, staticRenderFns } from "./madeToMeasure.vue?vue&type=template&id=545c1a6a&"
import script from "./madeToMeasure.vue?vue&type=script&lang=js&"
export * from "./madeToMeasure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports